import { SxProps } from "@mui/material"
import { action, makeObservable, observable } from "mobx"

export type MenuItem<T> = { title?: React.ReactNode, icon?: React.ReactNode, sx?: SxProps, onClick?: (item: T) => void, sub?: string }
export type Creator<T> = (item: T) => (MenuItem<T> | false | null | undefined)[]

class ContextMenuStore<T> {

  menuItems = observable.array<MenuItem<T>>([])
  menuAnchorPos = { top: 0, left: 0 }
  opened = false
  item: T | null = null
  creator: Creator<T>

  constructor(creator: Creator<T>) {
    this.creator = creator
    makeObservable(this, {
      menuAnchorPos: observable,
      opened: observable,
      open: action.bound,
      close: action.bound
    })
  }

  open(e: React.MouseEvent, item?: T) {
    e.preventDefault()
    e.stopPropagation()
    this.menuItems.replace(this.creator(item!!).filter(item => !!item) as MenuItem<T>[])

    this.menuAnchorPos = { top: Math.round(e.clientY/4-1)*4, left: Math.round(e.clientX/4+0.2)*4 }
    this.opened = true
    this.item = item!!
  }

  close() {
    this.opened = false
  }

  handleClick(item: MenuItem<T>) {
    if (!item.onClick || this.item === null || !this.opened) return
    item.onClick(this.item)
    this.close()
  }

}

export default ContextMenuStore